import './App.css';
import LoginSignup from './Components/LoginSignup/Body/LoginSignup';



function App() {
  return (
    <div >
      
      <LoginSignup/>
    </div>
  );
}

export default App;
